import { normalizeReportConfig } from '../types'

/** Every library folder the saved reports use, for the folder field's suggestions. */
export function libraryFolders(designs: Array<{ filters?: { report?: unknown } | null }>): string[] {
  return [
    ...new Set(
      designs.map((item) =>
        normalizeReportConfig(item.filters?.report as Parameters<typeof normalizeReportConfig>[0]).folder,
      ),
    ),
  ]
    .filter(Boolean)
    .sort()
}
